import { ColumnDef, ColumnHelper } from '@tanstack/react-table'

import { commonAccessorColumn, moneyAccessorColumn } from '@/components/table'
import { SendUrlButton } from '@/components'
import { OperationRequest } from '@/types.ts'
import { OPERATION_REQUESTS_ENDPOINTS } from '@/services'

export const KEY_PAGE = 'operation-settings'

type VisibleColumns = 'id' | 'clientName' | 'clientEmail' | 'orderSum' | 'createTime' | 'validTo' | 'url'

export type PartialOperation = Pick<OperationRequest, VisibleColumns>

export const defaultSettings: Record<keyof PartialOperation, string> = {
  id: '№ заказа',
  clientName: 'ФИО Клиента',
  clientEmail: 'Email клиента',
  orderSum: 'Сумма',
  createTime: 'Дата создания',
  validTo: 'Действительна до',
  url: 'Ссылка на оплату',
}

export function getColumnsSettings(
  columnHelper: ColumnHelper<OperationRequest>
): Record<keyof PartialOperation, ColumnDef<OperationRequest, any>> {
  return {
    id: columnHelper.accessor('id', commonAccessorColumn('№ заказа')),
    clientName: columnHelper.accessor('clientName', commonAccessorColumn('ФИО Клиента')),
    clientEmail: columnHelper.accessor('clientEmail', commonAccessorColumn('Email клиента')),
    orderSum: columnHelper.accessor('orderSum', moneyAccessorColumn('Сумма')),
    createTime: columnHelper.accessor('createTime', commonAccessorColumn('Дата создания')),
    validTo: columnHelper.accessor('validTo', commonAccessorColumn('Действительна до')),
    url: columnHelper.accessor('url', commonAccessorColumn('Ссылка на оплату')),
  }
}

export const getStaticColumns = (
  columnHelper: ColumnHelper<OperationRequest>
): Record<string, ColumnDef<OperationRequest, any>> => {
  return {
    'send-url-action': columnHelper.display({
      id: 'send-url-action',
      enableSorting: false,
      cell: (props) => <SendUrlButton {...props.row.original} sendUrl={OPERATION_REQUESTS_ENDPOINTS.sendUrl} />,
    }),
  }
}
